/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { ReactElement, useCallback, useMemo } from 'react'
import { useSelectionContext } from './SelectionProvider'
import { Checkbox, Radio } from '@mantine/core'

function SelectionToggle (): ReactElement {
  const {
    items,
    multiple,
    source,
    toggleAll
  } = useSelectionContext()

  const isChecked = useMemo(() => (
    source.length > 0 && items.length === source.length
  ), [items.length, source.length])

  const handleClick = useCallback(() => {
    toggleAll()
  }, [toggleAll])

  const Component = multiple ? Checkbox : Radio

  return (
    <Component
      checked={isChecked}
      onChange={handleClick}
    />
  )
}

export default SelectionToggle
